import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppSettings } from '../../../app.settings';
@Component({
  selector: 'ifp-bank-account-decision-logic-dialog',
  templateUrl: './bank-account-decision-logic-dialog.component.html',
  standalone: false,
})
export class BankAccountDecisionLogicDialogComponent{
  constructor(
    public dialogRef: MatDialogRef<BankAccountDecisionLogicDialogComponent>,
    public settings: AppSettings,
  ) { }

  static show(dialog: MatDialog, requestCode: string): Observable<any> {
    let dialogRef = dialog.open(BankAccountDecisionLogicDialogComponent, {
      width: '452px',
      height: '706px',
      maxWidth: '100%',
      data: { },
      closeOnNavigation: true,
      disableClose: true
    });
    let interval : any;
    dialogRef.afterOpened().subscribe(_ => {
      let element = document.getElementById('widget3');
      element.setAttribute('request_code', requestCode);
      interval = setInterval(
        function() {
          let element = document.getElementById('widget3');
          if(element === null){
            dialogRef.close(false);
            return;
          }
          if (element.innerText.toLocaleLowerCase().includes("success")){
            dialogRef.close(true);
          }
        }, 10 * 1000
      );
    });
    dialogRef.afterClosed().subscribe(() => {
      if(interval)
        clearInterval(interval);
    });
    return dialogRef.afterClosed();
  }
}
